<template>
  <div class="flex-grow-1 d-flex flex-column overflow-y-hidden">
    <div class="a-header">
      <span class="a-header--title slide-down-enter-active">WHOIS Monitoring History</span>
    </div>
    <div class="d-flex justify-content-center align-items-center pt-35-px" v-if="isLoading">
      <Spinner />
    </div>
    <div v-resize="elSizeChange" class="a-body flex-grow-1 overflow-y-hidden">
      <transition name="slide-up">
        <template v-if="!isLoading">
          <PaginationTable
            :clientPaging="false"
            :pagination="pagin"
            :columns="MonitoringHistoryColumn"
            :dataSource="data"
            :tableSize="tableSize">
            <template slot="status" slot-scope="{ record }">
              <div>
                <a-tag :color="DomainStatusColor[record.status] || DomainStatusColor.NotOK" class="status-tag" role="button" @click="(e) => handleCompareRecord(e, record)">
                  {{ record.status }}
                </a-tag>
              </div>
            </template>
            <template slot="verifiedOn" slot-scope="{ record }">
              <div>
                <div>
                  <time>
                    {{ record.verifiedOn | dateString }}
                  </time>
                </div>
                <div>
                  <time>
                    {{ record.verifiedOn | timeString }}
                  </time>
                </div>
              </div>
            </template>
            <template slot="detail" slot-scope="{ record }">
              <div>
                {{ record.detail }}
              </div>
            </template>
          </PaginationTable>
        </template>
      </transition>
    </div>
    <div class="a-footer">
      <PaginationBar :pageSize.sync="pagin.pageSize" :total="pagin.total" @change="paginChange" />
    </div>
    <a-modal 
      v-model="isOpenCompareRecord"
      width="fit-content"
      cancelText="Close"
      title="Differences: Original Baseline - Latest Verification"
      :okButtonProps="{ style: { display: 'none' } }"
      :dialogStyle="{ top: '20px', maxWidth: '80vw' }"
      :bodyStyle="{ padding: '10px', overflowY: 'auto', height: 'auto', maxHeight: 'calc(80vh - 20px)' }">
      <div>
        <CodeDiff :oldString="capturedRecord" :newString="monitoringRecord" />
      </div>
    </a-modal>
  </div>
</template>

<script>
  import { PAGE_OPTIONS } from '@constants/pageOptions';
  import { indexItemTable } from '@shared/helpers/utils';
  import { DomainStatusColor } from '../consts/domainStatus.const';
  import { MonitoringHistoryColumn } from '../columnsTable/MonitoringHistoryColumn';
  import DomainMonitorService from '../services/DomainMonitor.service';
  import CodeDiff from '@shared/components/CodeDiff';

  export default {
    name: 'WHOISMonitoringHistory',
    components: {
      CodeDiff
    },
    data() {
      var pageSize = Number(window.localStorage.getItem("pageSize"));
      if(!pageSize)
       pageSize = 5;

      return {
        PAGE_OPTIONS,
        DomainStatusColor,
        MonitoringHistoryColumn,
        monitoringRecord: '',
        capturedRecord: '',
        isOpenCompareRecord: false,
        id: 0,
        data: [],
        pagin: {
          current: 1,
          pageSize: pageSize,
          total: 0
        },
        isLoading: true,
        tableSize: {
          height: '',
          width: ''
        }
      };
    },
    beforeMount() {
      this.id = this.$route.params.id;
    },
    mounted() {
      this.fetchHistory();
    },
    methods: {
      paginChange(pagin) {
        this.pagin = { ...pagin };
        this.fetchHistory();
      },
      async fetchHistory() {
        try {
          const response = await DomainMonitorService.fetchWhoisHistoryList(this.pagin, this.id);
          this.data = (response && response.data || []).map((item, index) => ({
            index: indexItemTable(this.pagin.current, this.pagin.pageSize, index),
            id: item.id,
            domain: item.domain || this.$route.params.domain,
            status: item.result,
            verifiedOn: item.timestamp,
            detail: item.reason,
          }));
          this.pagin.total = response && response.total || 0;
        } catch {
          this.$showErrorMessage('HTTP error received from web server.!');
        } finally {
          if (this.isLoading) {
            setTimeout(() => {
              this.isLoading = false;
            }, 300);
          }
        }
      },
      async handleCompareRecord(e, record) {
        e.stopPropagation();
        if (record.status === 'FAIL') {
          if (!this.monitoringRecord) {
            const monitoringData = await DomainMonitorService.fetchWhoisMonitoringRecordById(this.id);
            this.monitoringRecord = monitoringData.data;
          }
          const capturedData = await DomainMonitorService.fetchWhoisRecordCapturedByIdAndRecord(this.id, record.id);
          this.capturedRecord = capturedData.data;
          this.isOpenCompareRecord = true;
        }
      },
      elSizeChange(size) {
        this.tableSize = size;
      }
    }
  };
</script>
<style lang="scss" scoped>
.status-tag {
  width: fit-content;
  min-width: 50px;
  text-align: center;
}
</style>
